<template>
	<!-- 读者专栏 -- 我的云书 -->
	<div class="myYunshuBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox" v-if="height_scroll < 80">
				<div class="headerQuery">
					<!-- jumpUrl -->
					<div class="arrImg" @click="jumpUrl()">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile" @click="toYj">我的云卷</p>
				</div>
			</div>
			<div class="headerBox" v-if="height_scroll >= 80" style="background-color: #fff !important;">
				<div class="headerQuery">
					<!-- jumpUrl -->
					<div class="arrImg" @click="jumpUrl()">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile01">读者专栏</p>
				</div>
			</div>
		</van-sticky>
		<div class="bgc_img">
			<img src="../../assets/img/bgc_yunshu.png" alt="">
		</div>
		<div class="fixedBox">
			<div class="yunshuBox_navbar">
				<div class="yunshuNavbar_top">
					<img :src="userImg" alt="" class="headerImg">
					<div class="yunshuNavbar_top_left">
						<div class="yunjin_txt"><i>{{reader_collect.nickname}}</i>
							<!-- <img src="../../assets/img/bookinfoIcon.png" alt="" class="bookinfoIcon" v-if="reader_collect.is_vip == 3 ? true : false"/> -->
							<a class="margi_lef" v-if="reader_collect.is_vip == 3 ? true : false"></a>
							<span @click="shoucangFn" v-if="reader_collect.is_collect == 0">
								<img src="../../assets/img/iocn6.png" alt="" class="iocn6">
								收藏
							</span>
							<span @click="shoucangFn" v-else-if="reader_collect.is_collect == 1" class="celShowSc">
								<img src="../../assets/img/iocn6.png" alt="" class="iocn6">
								取消收藏
							</span>
						</div>
						<div class="scNum">
							<span>{{reader_collect.collect_count}}</span>
							<p>收藏数</p>
						</div>
					</div>
					<div class="jiangbeiImg">
						<span v-for="index in authorData.lianzai_num">
							<img src="../../assets/img/jiangbei.png" alt="">
						</span>
						<span v-for="index in authorData.wanjie_num">
							<img src="../../assets/img/jiangbei01.png" alt="">
						</span>
						<span v-for="index in authorData.zhanting_num">
							<img src="../../assets/img/jiangbei02.png" alt="">
						</span>
					</div>
				</div>
				<div class="yunshuNavbar_bottom">
					<div :class="navBarIndex == index ? 'active' : ''" @click="navbarFn(index)" v-for="(item,index) in navbar" :key="index">
						<span>{{item}}</span>
						<p></p>
					</div>
				</div>
			</div>
		</div>
		<!-- 收藏列表数据 -->
		<div class="blockBox" v-show="navBarIndex == 0 ? true : false">
			<div v-for="(item1,index) in reader_collect.collect_list" v-if="reader_collect.collect_list.length != 0">
				<p class="blockBox_tit">{{item1.name}}</p>
				<div class="blockLeft" v-for="(item,index) in item1.list" :key="index" @click="jumpBookinfo(item.books_id)">
					<div class="book_Img">
						<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
					</div>
					<div class="blockBookInfo">
						<div class="bookName">
							<!-- <p :style="{width:(item.books_name.length * 1 ) + 'em' }">{{item.books_name}}</p> -->
							<p>{{item.books_name}}</p>
						</div>
						<!-- <div class="auther" @click="toZz(item.user_id)"><span>{{item.author}}</span></div> -->
						<div class="auther"><span>{{item.author}}</span>
							<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p>
						</div>
						<p class="bookType">{{item.original_name}}-{{item.appetency_name}}-{{item.epoch_name}}-{{item.type_name}}</p>
						<div class="introduction">
							<p>{{item.introduce}}</p>
						</div>
						<div class="book_button">
							<button v-for="i in item.lable_list">{{i.name}}</button>
						</div>
					</div>
				</div>
			</div>
			<div v-if="reader_collect.collect_list.length == 0" class="data_null">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div>
		<!-- 书单列表数据 -->
		<!-- <div > -->
		<div class="modebook" v-show="navBarIndex == 1 ? true : false">
			<!-- 我收藏的书单 -->
			<div class="modebook_list">
				<!-- 排序方式 -->
				<div class="solt" v-if="reader_book_list.my_collect.length != 0">
					<div @click="toggle">
						<span v-model="queryTitle">{{queryTitle}}</span>
						<img src="../../assets/img/downarr.png" alt="" />
					</div>
					<ul v-show="selectItem" class="select_item">
						<li v-for="(item,index) in selectItemList" @click="query_select(index,item.txt)" :class="queryIndex == index ? 'activeQuery' : ''">
							<span>{{item.txt}}</span>
							<img v-show="queryIndex == index ? true : false" src="../../assets/img/query.png" alt="" />
						</li>
					</ul>
				</div>
				<!-- 列表数据 -->
				<div class="sdblockBox">
					<div class="blockLeft" v-for="(item,index) in reader_book_list.my_collect" v-if=" reader_book_list.my_collect.length != 0"
					 :key="item.id" @click="bookInfoFn(item.id)">
						<div class="book_Img">
							<div class="book_Img1" v-for='(it,ind) in item.cover_image'>
								<img :src="$api.$BASE_URL_img + it.cover_image" alt="" />
							</div>
						</div>
						<div class="blockBookInfo">
							<p class="bookName">{{item.name}}</p>
							<div class="auther"><span>{{item.maker}}</span></div>
							<p class="tjnum"><span>{{item.number}}本</span><span>{{item.collect_count}}人收藏</span></p>
						</div>
					</div>
				</div>
			</div>
			<div class="modebook_list">
				<!-- 排序方式 -->
				<div class="solt" v-if="reader_book_list.my_make.length != 0">
					<div @click="toggle1">
						<span v-model="queryTitle1">{{queryTitle1}}</span>
						<img src="../../assets/img/downarr.png" alt="" />
					</div>
					<ul v-show="selectItem1" class="select_item">
						<li v-for="(item,index) in selectItemList1" @click="query_select1(index,item.txt)" :class="queryIndex1 == index ? 'activeQuery' : ''">
							<span>{{item.txt}}</span>
							<img v-show="queryIndex1 == index ? true : false" src="../../assets/img/query.png" alt="" />
						</li>
					</ul>
				</div>
				<!-- 列表数据 -->
				<div class="sdblockBox">
					<div class="blockLeft" v-for="(item,index) in reader_book_list.my_make" :key="item.id" v-if="reader_book_list.my_make.length != 0"
					 @click="bookInfoFn(item.id)">
						<div class="book_Img">
							<div class="book_Img1" v-if='ind<3' v-for='(it,ind) in item.cover_image'>
								<img :src="$api.$BASE_URL_img + it.cover_image" alt="" />
							</div>
						</div>
						<div class="blockBookInfo">
							<p class="bookName">{{item.name}}</p>
							<div class="auther"><span>{{item.maker}}</span></div>
							<p class="tjnum"><span>{{item.number}}本</span><span>{{item.collect_count}}人收藏</span></p>
						</div>
					</div>
				</div>

			</div>
			<div v-if=" reader_book_list.my_collect.length == 0 && reader_book_list.my_make.length == 0" class="data_null">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div>
		<!-- 最近订阅列表数据 -->
		<div class="blockBox" v-show="navBarIndex == 2 ? true : false">
			<p class="blockBox_tit"></p>
			<div class="blockLeft" v-if="reader_history.length != 0" v-for="(item,index) in reader_history" :key="index" @click="jumpBookinfo(item.books_id)">
				<div class="book_Img">
					<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
				</div>
				<div class="blockBookInfo">
					<div class="bookName">
						<!-- <span class="name">{{item.books_name}}</span> -->
						<p :style="{width:(item.books_name.length * 1 ) + 'em' }">{{item.books_name}}</p>
						<!-- <p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p> -->
					</div>
					<!--  @click="toZz(item.user_id)" -->
					<div class="auther"><span>{{item.author}}</span>
						<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p>
					</div>
					<p class="bookType">{{item.original_name}}-{{item.appetency_name}}-{{item.epoch_name}}-{{item.type_name}}</p>
					<div class="introduction">
						<p>{{item.introduce}}</p>
					</div>
					<div class="book_button">
						<button v-for="(it,ind) in item.lable_list">{{it.name}}</button>
					</div>
				</div>
			</div>
			<div v-if="reader_history.length == 0" class="data_null">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div>


	</div>
</template>

<script>
	import {
		Toast
	} from 'vant'
	export default {
		data() {
			return {
				selectItem: false,
				selectItem1: false,
				navBarIndex: 0,
				navbar: ["收藏", "书单", "最近订阅"],
				queryIndex: 0,
				queryIndex1: 0,
				queryTitle: '收藏的书单',
				queryTitle1: '制作的书单',
				selectItemList: [{
						txt: '按收藏数'
					},
					{
						txt: '按积分'
					},
					{
						txt: '按更新时间'
					},
					{
						txt: '按发表时间'
					},
					{
						txt: '按字数'
					},
				],
				selectItemList1: [{
						txt: '按收藏数'
					},
					{
						txt: '按积分'
					},
					{
						txt: '按更新时间'
					},
					{
						txt: '按发表时间'
					},
					{
						txt: '按字数'
					},
				],
				user_id: '',
				reader_collect: {},
				reader_book_list: {},
				reader_history: [],
				cityPage: '',
				showSc: true,
				authorData: {},
				userImg: '',
				height_scroll: 0,
			}
		},
		created() {
			this.user_id = this.$route.query.user_id;
			this.cityPage = this.$route.query.url;
			// this.authorData = this.$route.query.autherInfo;
			this.getReader_collect();
			this.get_reader_book_list();
			this.get_reader_history();
		},
		methods: {
			shoucangFn() {
				this.$axios.post(this.$api.collect_user, {
					user_id: this.user_id
				}).then(res => {
					if (res.data.code == 1) {
						this.getReader_collect();
					}
					Toast(res.data.msg);
				})

			},
			navbarFn(data) {
				console.log(data, 'data')
				this.navBarIndex = data;
				if (data == 0) {
					this.getReader_collect()
				} else if (data == 1) {
					this.get_reader_book_list()
				} else {
					this.get_reader_history()
				}
			},
			toggle() {
				this.selectItem = !this.selectItem
			},
			toggle1() {
				this.selectItem1 = !this.selectItem1
			},
			query_select(index, txt) {
				console.log(index)
				this.queryIndex = index
				this.queryTitle = txt
				this.selectItem = !this.selectItem
			},
			query_select1(index, txt) {
				console.log(index)
				this.queryIndex1 = index
				this.queryTitle1 = txt
				this.selectItem1 = !this.selectItem1
			},
			modeToggle() {
				console.log('/modeToggle')
				this.modeSelectItem = !this.modeSelectItem
			},
			jumpUrl() {
				if (this.$route.query.url == 'zzzl' && this.$route.query.active == 2) {
					this.$router.push({
						path: '/bookshelf',
						query: {
							com_name: 'cp',
							active: 2
						}
					})
				} else {
					this.$router.go(-1);
				}
			},
			toYj() {
				this.$router.push({
					path: '/autherZl',
					query: {
						url: this.cityPage,
						user_id: this.$route.query.user_id
					}
				})
			},
			//读者专栏收藏
			getReader_collect() {
				this.$axios.post(`${this.$api.reader_collect}?user_id=${this.user_id}`).then(res => {
					if (res.status == 200) {
						this.reader_collect = res.data.data;
						console.log(this.reader_collect.collect_list.length)
						if (this.reader_collect.avatar.indexOf("https://thirdwx.qlogo.cn/") != -1) {
							this.userImg = this.reader_collect.avatar;
						} else if (this.reader_collect.avatar.indexOf("http://thirdqq.qlogo.cn/") != -1) {
							this.userImg = this.reader_collect.avatar;
						} else {
							this.userImg = `${this.$api.$BASE_URL_img}${this.reader_collect.avatar}`;
						}
					}
				})
			},
			//读者书单
			get_reader_book_list() {
				this.$axios.post(`${this.$api.reader_book_list}?user_id=${this.user_id}`).then(res => {
					if (res.status == 200) {
						console.log(res, '读者书单')
						this.reader_book_list = res.data.data
					}
				})
			},
			//读者最新订阅
			get_reader_history() {
				this.$axios.post(`${this.$api.reader_history}?user_id=${this.user_id}`).then(res => {
					if (res.status == 200) {
						console.log(res, '读者最新订阅')
						this.reader_history = res.data.data
					}
				})
			},
			// 跳转详情页
			jumpBookinfo(val) {
				this.$router.push({
					path: '/bookinfo',
					query: {
						id: val,
						urlDz: 'dzzhuanlan',
						url: this.cityPage,
						active: this.$route.query.active
						// id: this.$route.query.id
					}
				})
			},
			//作者专栏
			toZz(val) {
				this.$router.push({
					path: '/autherZl',
					query: {
						// user_id: val,
						id: this.book_id
					}
				})
			},
			// 书单详情
			bookInfoFn(id) {
				console.log(id, 'id');
				this.$router.push({
					path: "/bookdyinfo",
					query: {
						id: id,
						url: 'dzzhuanlan'
					}
				})
			},
			handleScroll() {
				this.height_scroll = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
			},
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
		},
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll) //  离开页面清除（移除）滚轮滚动事件
		}
	}
</script>

<style lang="less" scoped>
	.data_null {
		img {
			width: 160px;
			position: absolute;
			top: 25%;
			left: 50%;
			transform: translate(-50%, -25%);
		}
	}

	.myYunshuBox {
		height: 100vh;
		background-color: #fff;
		color: #000000;

		// 头部
		.headerBox {
			height: 160px;
			background-color: transparent;
			display: flex;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 50px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
				z-index: 100;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: right;
					font-size: 32px;
					/*px*/
				}
				.header_titile01{
					flex: 1;
					text-align: center;
					font-size: 32px;
					/*px*/
				}
			}

		}

		.bgc_img {
			img {
				width: 100%;
				position: fixed;
				top: 0;
				left: 0;
			}
		}

		.fixedBox {
			width: 100vw;
			position: absolute;
			z-index: 100;
			top: 166px;
			left: 0;
			background-color: #fff;
		}

		.yunshuBox_navbar {
			height: 230px;
			padding: 20px;
			padding-bottom: 20px;
			width: calc(100vw - 80px);
			margin: 0 auto;
			border-radius: 20px;
			background-color: #fff;
			-webkit-box-shadow: 0 0 3px 0 rgba(0, 0, 0, .3);
			/*no*/
			-moz-box-shadow: 0 0 3px 0 rgba(0, 0, 0, .3);
			/*no*/
			box-shadow: 0 0 3px 0 rgba(0, 0, 0, .3);

			/*no*/
			.yunshuNavbar_top {
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				.headerImg {
					position: absolute;
					top: -40px;
					left: 50px;
					width: 120px;
					height: 120px;
					border-radius: 50%;
					overflow: hidden;
					-webkit-box-shadow: 0 0 3px 0 rgba(0, 0, 0, .3);
					/*no*/
					-moz-box-shadow: 0 0 3px 0 rgba(0, 0, 0, .3);
					/*no*/
					box-shadow: 0 0 3px 0 rgba(0, 0, 0, .3);
					/*no*/
					background-color: #fff;
				}

				.yunshuNavbar_top_left {
					.yunjin_txt {
						margin-left: 144px;

						i {
							font-style: normal;
							font-size: 30px;
							/*px*/
						}

						span {
							margin-left: 20px;
							display: inline-block;
							width: 100px;
							height: 40px;
							border-radius: 40px;
							background-color: #ffebee;
							text-align: center;
							color: #fa7089;
							position: relative;

							.iocn6 {
								position: absolute;
								top: -5px;
								left: -5px;
								width: 30px;
							}
						}

						.celShowSc {
							width: 140px;
						}
					}

					.scNum {
						position: absolute;
						top: 20px;
						right: 50px;
						text-align: center;
					}

					.rabitt {
						img {
							position: absolute;
							right: 20px;
							top: 0;
							width: 180px;
						}
					}
				}

				.jiangbeiImg {
					padding-top: 40px;
					padding-bottom: 20px;
					padding-left: 20px;

					img {
						margin-right: 10px;
						width: 50px;
					}
				}
			}

			.yunshuNavbar_bottom {
				display: flex;
				padding-top: 10px;

				div {
					flex: 1;
					text-align: center;
					font-size: 30px;
					/*px*/
					position: relative;
					color: #1f1f1f;

					span {
						width: 100%;
						line-height: 60px;
						display: inline-block;
					}

					p {
						width: 95px;
						height: 4px;
						position: absolute;
						bottom: -5px;
						left: 50%;
						transform: translateX(-50%);
						background-color: transparent;
						border-radius: 4px;
					}

				}

				div.active {
					p {
						background-color: #ff4081;
					}

					span {
						color: #ff4081;
					}
				}


			}
		}

		//收藏列表数据
		.blockBox {
			height: calc(100vh - 380px);
			// overflow-y: scroll;
			margin-top: 300px;
			// overflow: hidden;
			position: relative;
			background-color: #fff;
			padding: 0px 20px;

			.blockBox_tit {
				height: 40px;
				line-height: 40px;
				font-size: 30px;
				/*px*/
				color: #1f1f1f;
				font-weight: 400;
			}

			.blockLeft {
				display: flex;
				background-color: #fff;
				padding: 20px 0px;
				padding-bottom: 20px;
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				.book_Img {
					// width: 138px;
					height: 280px;

					img {
						width: 180px;
						height: 270px;
						display: block;
						float: left;
						-webkit-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
						/*no*/
						-moz-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
						/*no*/
						box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
						/*no*/
					}
				}

				.blockBookInfo {
					margin-left: 10px;
					flex: 1;
					font-size: 26px;
					/*px*/
					line-height: 30px;

					.auther {
						color: #000;
						font-size: 26px;
						/*px*/
						opacity: 0.6;

						p {
							display: inline-block;
							float: right;
							font-weight: 400;

							span {
								margin-left: 8px;
								color: #4c4c4c;
								font-size: 26px;
								/*px*/
							}
						}
					}

					.auther {
						color: #000;
						opacity: 0.6;
						font-size: 26px;
						/*px*/
						padding-top: 10px;
					}

					.bookType,
					.introduction {
						padding-top: 10px;
						color: #000;
						opacity: 0.4;
						font-size: 24px;
						/*px*/
					}

					.bookName {
						font-size: 30px;
						/*px*/
						color: #000000;
						font-weight: normal;
						width: 500px;
						height: 40px;
						line-height: 40px;
						overflow: hidden;
						overflow-x: scroll;

						p {
							// font-weight: 700;
							font-size: 30px;
							/*px*/
							height: 40px;
							display: inline-block;
							color: #000000;
							opacity: 1;
							width: 200%;
						}
					}

					.introduction {
						width: 60vw;
						padding-top: 15px;

						p {
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
						}
					}

					.book_button {
						margin-top: 25px;

						button {
							outline: none;
							border: 0;
							border: 1px solid #fec6d5;
							/*no*/
							border-radius: 28px;
							padding: 0px 20px;
							display: inline-block;
							// padding-top: 5px;
							// line-height: 40px;
							background-color: #fff8fa;
							color: #fa7298;
							margin-right: 20px;
							font-size: 24px;
							/*px*/
							margin-bottom: 10px;
						}

						.active {
							background-color: #fa7298;
							color: #ffffff;
						}
					}
				}
			}

		}

		//书单列表数据
		// .bookDan{

		.modebook {
			height: calc(100vh - 380px);
			overflow-y: scroll;
			margin-top: 300px;
			// overflow: hidden;
			position: relative;

			background-color: #fff;

			.modebook_list {
				// margin-bottom: 10px;
				background-color: #fff;

				//排序方式
				.solt {
					background-color: #fff;
					position: relative;
					padding: 0 16px;
					height: 40px;
					line-height: 40px;
					padding-top: 10px;

					div {
						span {
							font-size: 32px;
							/*px*/
						}

						img {
							margin-left: 10px;
							width: 20px;
						}

					}

					ul {
						position: absolute;
						top: 80px;
						left: 100px;
						background-color: #fff;
						z-index: 100;
						padding: 0 20px;

						// box-shadow: 0 0 5px 0 rgba(0,0,0,.3);/*no*/
						li {
							line-height: 50px;
							border-bottom: 1px solid #f0f0f0;

							span {
								font-size: 28px;
								/*px*/
							}

							img {
								margin-left: 10px;
								width: 20px;
								height: 20px;
							}
						}

						.select_item {
							width: 100px;
							border-radius: 20px;
						}

						.activeQuery {
							color: #ff4081;
							border-bottom: 4px solid #f0f0f0;
							/*no*/
						}
					}
				}

				//列表数据
				.sdblockBox {
					margin: 0;
					position: relative;
					background-color: #fff;
					padding: 0 16px;

					.blockLeft {
						display: flex;
						background-color: #fff;
						padding: 20px 0px;
						padding-bottom: 20px;
						border-bottom: 1px solid #f0f0f0;

						/*no*/
						.book_Img {
							width: 220px;
							height: 240px;
							// float: left;
							position: relative;

							.book_Img1:nth-child(3) {
								img {
									height: 120px;
									display: block;
									position: absolute;
									left: 130px;
									top: 50%;
									transform: translateY(-50%);
									-webkit-transform: translatez(-55%);
									-moz-transform: translatez(-55%);
									box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, .3);
									/*no*/
									z-index: 1;
								}
							}

							.book_Img1:nth-child(2) {
								img {
									height: 150px;
									display: block;
									position: absolute;
									left: 80px;
									top: 50%;
									transform: translateY(-50%);
									-webkit-transform: translatez(-50%);
									-moz-transform: translatez(-50%);
									box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, .3);
									/*no*/
									z-index: 2;
								}
							}

							.book_Img1:nth-child(1) {

								img {
									height: 200px;
									display: block;
									position: absolute;
									left: 10px;
									top: 50%;
									transform: translateY(-50%);
									-webkit-transform: translatez(-20%);
									-moz-transform: translatez(-20%);
									box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, .3);
									/*no*/
									z-index: 3;
								}
							}
						}

						.blockBookInfo {
							margin-left: 10px;
							flex: 1;
							font-size: 26px;
							/*px*/
							line-height: 60px;
							padding: 20px 0;
							position: relative;

							.bookName {
								font-size: 30px;
								/*px*/
								font-weight: normal;
								color: #000000;
								padding: 0;
							}

							.auther {
								color: #000;
								font-size: 26px;
								/*px*/
								padding: 0;
								opacity: 0.6;
							}

							.tjnum {
								span {
									margin-right: 8px;
									color: #000;
									font-size: 24px;
									/*px*/
									opacity: 0.4;
								}

							}

							.bookType,
							.introduction {
								padding-top: 20px;
								color: #a3a3a3;
							}

							.introduction {
								width: 60vw;
								padding-top: 15px;

								p {
									overflow: hidden;
									white-space: nowrap;
									text-overflow: ellipsis;
								}
							}

							.book_button {
								margin-top: 25px;

								button {
									border: 0;
									outline: none;
									border: 1px solid #fec6d5;
									/*no*/
									border-radius: 28px;
									padding: 0 20px;
									line-height: 40px;
									/*px*/
									background-color: #fff8fa;
									color: #fa7298;
									margin-right: 20px;
									font-size: 26px;
									/*px*/
								}

								.active {
									background-color: #fa7298;
									color: #ffffff;
								}
							}
						}
					}

				}

			}
		}

		// }

	}
</style>
